import { useQuery } from "@tanstack/react-query";
import { getAtreemoMappings } from "../../api/bAtreemoApi";

export const useGetAtreemoMappings = (organisationId) => {
  return useQuery({
    queryKey: ["atreemo-mappings", organisationId],
    queryFn: () => getAtreemoMappings(organisationId),
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    onError: (error) => {
      console.error("Error fetching Atreemo mappings:", error.response || error);
    },
  });
};
